import { useMemo } from "react"
import { useQuery } from "urql"

import {
  GetTransferWarehouseDocument,
  type WarehouseArea,
  type WarehouseAreaGetSuccess,
} from "@/graphql/codegen/graphql"

interface UseGetTransferWarehouseReturn {
  warehouseArea: WarehouseArea | null
  isFetching: boolean
}

export const useGetTransferWarehouse = (warehouseAreaId: string): UseGetTransferWarehouseReturn => {
  const [{ data, fetching }] = useQuery({
    query: GetTransferWarehouseDocument,
    variables: { input: { warehouseAreaId } },
    pause: !warehouseAreaId,
  })

  const output = data?.warehouseArea.get

  const warehouseArea = useMemo((): WarehouseArea | null => {
    if (output?.__typename === "WarehouseAreaGetSuccess") {
      return (output as WarehouseAreaGetSuccess).warehouseArea
    }

    return null
  }, [output])

  return { warehouseArea, isFetching: fetching }
}
